import { Controller } from "@hotwired/stimulus"

const DELAY = 500
const SLOP = 8

export default class extends Controller {
  connect() {
    if (document.body.dataset.nativeApp !== "true") return

    this.down = this.down.bind(this)
    this.move = this.move.bind(this)
    this.release = this.release.bind(this)
    this.swallow = this.swallow.bind(this)
    this.element.addEventListener("pointerdown", this.down)
    this.element.addEventListener("pointermove", this.move)
    this.element.addEventListener("pointerup", this.release)
    this.element.addEventListener("pointercancel", this.release)
    this.element.addEventListener("contextmenu", this.swallow)
    this.element.addEventListener("click", this.swallow, true)
    this.listening = true
  }

  disconnect() {
    if (!this.listening) return

    this.clear()
    this.element.removeEventListener("pointerdown", this.down)
    this.element.removeEventListener("pointermove", this.move)
    this.element.removeEventListener("pointerup", this.release)
    this.element.removeEventListener("pointercancel", this.release)
    this.element.removeEventListener("contextmenu", this.swallow)
    this.element.removeEventListener("click", this.swallow, true)
  }

  down(event) {
    if (event.target.closest("a, button, form, trix-editor, [role=menu]")) return

    this.startX = event.clientX
    this.startY = event.clientY
    this.pressing = true
    this.fired = false
    this.element.classList.add("review-comment--pressed")
    this.timer = setTimeout(() => this.fire(), DELAY)
  }

  move(event) {
    if (!this.timer) return
    if (Math.abs(event.clientX - this.startX) > SLOP || Math.abs(event.clientY - this.startY) > SLOP) this.clear()
  }

  release() {
    if (!this.pressing) return

    this.pressing = false
    if (this.fired) {
      this.fired = false
      this.suppressUntil = Date.now() + 400
      return
    }
    this.clear()
  }

  fire() {
    this.timer = null
    this.fired = true
    const menu = this.element.querySelector(".comment-menu")
    if (menu) menu.dispatchEvent(new CustomEvent("long-press:fire"))
    else this.clear()
  }

  swallow(event) {
    const pendingPress = !!this.timer
    const justReleased = Date.now() < (this.suppressUntil || 0)
    this.suppressUntil = 0
    if (!pendingPress && !justReleased) return
    if (event.target.closest("[role=menu]")) return

    event.preventDefault()
    event.stopPropagation()
  }

  clear() {
    clearTimeout(this.timer)
    this.timer = null
    this.element.classList.remove("review-comment--pressed")
  }
}
